"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @since 15.0.0
 */
function getRootUrl() {
    return OC.getRootPath();
}
exports.getRootUrl = getRootUrl;
/**
 * @since 15.0.0
 */
function generateUrl(url, params, options) {
    return OC.generateUrl(url, params, options);
}
exports.generateUrl = generateUrl;
/**
 * @since 15.0.0
 */
function generateFilePath(app, type, file) {
    return OC.filePath(app, type, file);
}
exports.generateFilePath = generateFilePath;
/**
 * @since 15.0.0
 */
function generateRemoteUrl(service) {
    return OC.linkToRemote(service);
}
exports.generateRemoteUrl = generateRemoteUrl;
/**
 * @since 15.0.0
 */
function generateOcsUrl(service, version) {
    if (version === void 0) { version = 2; }
    return OC.linkToOCS(service, version);
}
exports.generateOcsUrl = generateOcsUrl;
